<template>
  <div class="white-container full-page-container common-table">
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item" label="勋章名称">
        <el-input v-model="search.name" placeholder="输入勋章名称" />
      </el-form-item>
      <el-form-item label="勋章类型">
        <el-select v-model="search.type" placeholder="请选择勋章类型">
          <el-option label="全部" :value="null" />
          <el-option v-for="item in categoryList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="search.status" placeholder="请选择状态">
          <el-option label="不限" :value="null" />
          <el-option v-for="item in medalStatus" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="activity-table">
      <tableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.medal.fetchMedaltList" style="width: 100%">
        <el-table-column prop="unlockImg" label="勋章图片" width="auto">
          <template v-slot="{row}">
            <img :src="row.unlockImg" style="width: 80px;" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="name" label="勋章名称" width="auto" />
        <el-table-column prop="memberNum" label="获取人数" />
        <el-table-column prop="type" label="勋章类型">
          <template v-slot="{row}">
            {{ categoryList.find(item=> item.id ===row.type)?.value || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="description" label="解锁说明" min-width="180" />
        <el-table-column prop="status" label="状态">
          <template v-slot="{row}">
            <el-tag :type="medalStatus[row.status].color" size="mini">{{ medalStatus[row.status].value }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="280px" label="操作">
          <template v-slot="{row}">
            <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="postOnlineMedal(row.id)">上线</el-button>
            <el-button v-if="row.status === 0" size="small" type="text" class="link-color" @click="postOfflineMedal(row.id)">下线</el-button>
            <el-button v-if="row.status === 0 && row.importSupported" size="small" type="text" class="link-color" @click="openImport(row.id)">导入</el-button>

          </template>
        </el-table-column>
      </tableList>
    </div>
    <!-- 上传球队弹窗 -->
    <el-dialog v-if="importDialogShow" :visible="importDialogShow" title="上传名单" custom-class="share-wrapper" @close="handleClose">
      <div class="upload-wrapTop">
        <div class="tips">下载导入模板，根据模板完善内容</div>
        <div class="coupon_tip" @click="downloadFileTemplate">
          <i class="el-icon-document" />下载文件模板
        </div>
      </div>
      <div class="upload-wrap">
        <div class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
        <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false">
          <div>
            <div style="height: 50px">
              <svg-icon icon-class="xls" style="width: 50px; height: 50px" />
            </div>
            <el-button v-if="!importExcel" size="small">选择文件</el-button>
            <template v-else>
              <div class="file">{{ importExcel.name }}</div>
              <el-button size="small">重新选择</el-button>
            </template>
          </div>
        </el-upload>
      </div>
      <div class="flex btns">
        <el-button type="info" @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import { getFileType } from "@/common/js/util";
export default {
  components: { tableList },
  data() {
    const categoryList = [
      { id: 1, value: 'AI体测', color: 'success' },
      { id: 2, value: '视频课程', color: 'success' },
      { id: 3, value: '跑步', color: 'success' },
      { id: 4, value: '骑行', color: 'success' },
      { id: 5, value: 'UA Star', color: 'success' },
      { id: 7, value: '答题挑战', color: 'success' },
      { id: 8, value: '月度挑战', color: 'success' },
    ];
    const medalStatus = [
      { id: 0, value: '已上线', color: 'success' },
      { id: 1, value: '已下线', color: 'warning' }];
    return {
      categoryList,
      medalStatus,
      search: {
        status: null,
        type: null,
        name: '',
      },
      importDialogShow: false,
      currentID: -1,
      importExcel: null, // 勋章佩戴名单
      information: {},
    };
  },

  methods: {
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.searchSubmit();
      });
    },
    // 上线勋章
    postOnlineMedal(id) {
      const param = {
        id,
        status: 0,
      };
      this.$Api.medal.upMedaltStatus(param).then(() => {
        this.$message.success('上线成功');
        this.searchSubmit();
      });
    },
    // 下线勋章
    postOfflineMedal(id) {
      const param = {
        id,
        status: 1,
      };
      this.$Api.medal.upMedaltStatus(param).then(() => {
        this.$message.success('下线成功');
        this.searchSubmit();
      });
    },
    // 打开导入名单
    openImport(id) {
      this.currentID = id;
      this.importDialogShow = true;
    },
    // 下载勋章佩戴模版
    downloadFileTemplate() {
      const fileUrl =
        "https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/excel/%E5%8B%8B%E7%AB%A0%E5%AF%BC%E5%85%A5%E5%90%8D%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx";
      window.open(fileUrl);
    },
    // 勋章导入名单弹窗关闭
    handleClose() {
      this.importDialogShow = false;
      this.importExcel = null;
    },
    // 勋章导入名单弹窗保存
    handleSave() {
      if (!this.importExcel) {
        this.$message.warning("请先选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importExcel);
      formData.append("id", this.currentID);
      this.$Api.medal.putMedalUp(formData).then(res => {
        this.$message.success("导入成功");
        this.searchSubmit();
        this.handleClose();
      });
    },
    handlePushUploader(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        return;
      }
      this.importExcel = file.raw;
    },
  },
};
</script>
<style lang="less" scoped>
.el-dialog__wrapper {
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  /deep/ .share-wrapper-box {
    width: 678px;
    margin: unset !important;
    .el-dialog__header {
      box-sizing: border-box !important;
      height: 6.85vh !important;
      padding: 0 2.87vh 0 2.78vh !important;

      background: #000000 !important;

      line-height: 6.85vh;
      .el-dialog__title {
        color: #ffffff;

        font-family: "Noto Sans SC";
        font-size: 1.48vh;
        font-weight: 500;
        font-style: normal;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;

        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      overflow-y: auto;

      max-height: calc(100vh - 6.85vh - 66px - 30px - 30px);
      padding: 2.5vh 0 2.78vh 0;
    }
  }
  /deep/ .share-wrapper {
    width: 538px;
    margin: unset !important;
    .el-dialog__header {
      box-sizing: border-box !important;
      height: 6.85vh !important;
      padding: 0 2.87vh 0 2.78vh !important;

      background: #000000 !important;

      line-height: 6.85vh;
      .el-dialog__title {
        color: #ffffff;

        font-family: "Noto Sans SC";
        font-size: 1.48vh;
        font-weight: 500;
        font-style: normal;
      }
    }
    .el-dialog__body {
      padding: 30px;
      .upload-wrapTop {
        width: 100%;
        height: 114px;
        margin-bottom: 20px;
        padding: 20px 30px;

        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        background: #f7f7f7;
        > .tips {
          margin-bottom: 20px;

          color: #494949;

          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
        > .coupon_tip {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 130px;
          height: 34px;

          cursor: pointer;
          user-select: none;

          color: #000000;
          border: 1px solid #bbbbbb;
          border-radius: 4px;
          background: #ffffff;

          font-size: 14px;
          line-height: 20px;
          > i {
            margin-right: 7px;
          }
        }
        > .coupon_tip:hover {
          color: #afafaf;
          background: #f7f7f7;
        }
      }
      .upload-wrap {
        box-sizing: border-box;
        width: 100%;
        height: 250px;
        padding: 20px 30px;

        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        background: #f7f7f7;
        .el-input__inner {
          height: 34px !important;
        }
        .el-upload-dragger {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 100%;
          height: 100%;
        }
        .tips {
          margin-bottom: 20px;

          color: #494949;

          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: 400;
          font-style: normal;
          line-height: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              display: flex;
              align-items: center;
              justify-content: center;

              width: 100%;
              height: 100%;

              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                margin-top: 5.68px;

                line-height: 20px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;

      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
/deep/ .share-wrapper {
  width: 538px;
  margin: unset !important;
  .el-dialog__header {
    box-sizing: border-box !important;
    height: 6.85vh !important;
    padding: 0 2.87vh 0 2.78vh !important;

    background: #000000 !important;

    line-height: 6.85vh;
    .el-dialog__title {
      color: #ffffff;

      font-family: "Noto Sans SC";
      font-size: 1.48vh;
      font-weight: 500;
      font-style: normal;
    }
    .el-dialog__headerbtn {
      top: 2.87vh;
      right: 2.87vh;

      font-size: 1.11vh;
      .el-dialog__close {
        color: #ffffff;
        &:hover {
          color: #dc0019;
        }
      }
    }
  }
  .el-dialog__body {
    padding: 30px;
    .upload-wrapTop {
      width: 100%;
      height: 114px;
      margin-bottom: 20px;
      padding: 20px 30px;

      border: 1px dashed #bbbbbb;
      border-radius: 4px;
      background: #f7f7f7;
      > .tips {
        margin-bottom: 20px;

        color: #494949;

        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
      > .coupon_tip {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 130px;
        height: 34px;

        cursor: pointer;
        user-select: none;

        color: #000000;
        border: 1px solid #bbbbbb;
        border-radius: 4px;
        background: #ffffff;

        font-size: 14px;
        line-height: 20px;
        > i {
          margin-right: 7px;
        }
      }
      > .coupon_tip:hover {
        color: #afafaf;
        background: #f7f7f7;
      }
    }
    .upload-wrap {
      box-sizing: border-box;
      width: 100%;
      height: 250px;
      padding: 20px 30px;

      border: 1px dashed #bbbbbb;
      border-radius: 4px;
      background: #f7f7f7;
      .el-input__inner {
        height: 34px !important;
      }
      .el-upload-dragger {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
      }
      .tips {
        margin-bottom: 20px;

        color: #494949;

        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: 400;
        font-style: normal;
        line-height: 20px;
      }
      .upload-box {
        width: 100%;
        height: 156px;

        .el-upload.el-upload--text {
          width: 100%;
          height: 100%;
          .el-upload-dragger {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 100%;
            height: 100%;

            border: 1px solid #bbbbbb;
            border-radius: 4px;
            &:hover {
              border-color: #1c1c1c;
            }
            .file {
              margin-top: 5.68px;

              line-height: 20px;
            }
            .el-button {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  .btns {
    justify-content: center;

    margin-top: 30px;
    .el-button {
      width: 120px;
      height: 50px;
    }
    .el-button + .el-button {
      margin-left: 30px;
    }
  }
}
</style>
